import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["toggleButton", "additionalChanges"]

  toggleChanges(event) {
    const itemId = event.currentTarget.getAttribute('data-item-id')
    const additionalChanges = this.additionalChangesTargets.find(target => 
      target.getAttribute('data-item-id') === itemId
    )
    const toggleButton = event.currentTarget

    if (additionalChanges.classList.contains('hidden')) {
      additionalChanges.classList.remove('hidden')
      toggleButton.textContent = toggleButton.textContent.replace('weitere', 'weniger')
    } else {
      additionalChanges.classList.add('hidden')
      toggleButton.textContent = toggleButton.textContent.replace('weniger', 'weitere')
    }
  }
}
